const field = (label, description) => ({ label, description });
const section = (title, description = "", info = "") => ({
  title,
  description,
  info,
});

export const DATA_FORM_CS_FIELD_META = {
  sctpInd: field(
    "Reviewed by Singapore Chartered Tax Professionals (SCTP)",
    "The return has been reviewed by a person who is a Singapore Chartered Tax Professionals Limited (SCTP) Accredited Tax Advisor, Accredited Tax Practitioner or Accredited Tax Practitioner (Provisional) for Income Tax."
  ),
  sctpName: field(
    "SCTP (Singapore Chartered Tax Professionals) name",
    "Name of the Singapore Chartered Tax Professionals reviewer."
  ),
  sctpNo: field(
    "SCTP (Singapore Chartered Tax Professionals) membership no.",
    "Singapore Chartered Tax Professionals membership number. Enter strictly in XXX#### format, with no space between the alphabets and numbers."
  ),
  basisPeriodFrom: field("Basis period from", "Current Period Start Date"),
  basisPeriodTo: field("Basis period to", "Current Period End Date"),
  fsPrep: field(
    "Financial statements prepared",
    "How many sets of financial statements did the company prepare for the period declared?"
  ),
  firstFYE: field(
    "First set - financial year end",
    "The financial year end of the first set of financial statements."
  ),
  prevFYE: field(
    "Previous financial year end",
    "There is a change in the company's financial year end. The financial year end of the company before the change."
  ),
  profitLossBeforeTaxation: field(
    "Profit/loss before taxation",
    "Net Profit / (Loss) before Tax as per Financial Statements"
  ),
  sepSrcIncome: field("Separate source income", ""),
  receiptNotTxAmt: field("Receipts not taxable", "Non-Taxable Income"),
  c1_NTDeductibleExp: field("Non-Tax Deductible Expenses", ""),
  adjPLBefDed: field("Adjusted Profit / (Loss) before Other Deductions", ""),
  renoWorksExpS14Q: field(
    "Renovation / refurbishment (S14N)",
    "Deduction for Renovation or Refurbishment Works under Section 14N"
  ),
  c1_FurtherDed: field(
    "Further / Other Deductions",
    "Further Deductions / Other Deductions"
  ),
  sgAdjPLAft: field(
    "Adjusted Profit / (Loss) before Capital Allowances",
    "Adjusted profit/loss after deductions (before capital allowances)"
  ),
  c1_BC: field("Balancing charge", ""),
  unutilCABFNorm: field(
    "Unutilised capital allowances (CA) brought forward",
    ""
  ),
  cyCANorm: field("Current year capital allowances", ""),
  unutilLossBFNorm: field("Unutilised losses brought forward", ""),
  cyOverseasDonation: field("Current Year Overseas Donations", ""),
  c1_GrossRent: field("Gross Rental Income", ""),
  c1_DedExp: field("Deductible rental expenses", ""),
  sgRent: field("Net rental income", ""),
  sgIntDisc: field("Interest / discount income", ""),
  sgOtherI: field("Other taxable income", ""),
  totSgFI: field("Total Income / (Losses) before Donations", ""),
  unutilDonationBFNorm: field("Unutilised donations brought forward", ""),
  cyDonation: field("Current Year Donations", ""),
  ci: field(
    "Chargeable income after donations",
    "Total Income / (Losses) after Donations"
  ),
  unutilCACFNorm: field(
    "Unutilised capital allowances (CA) carried forward",
    ""
  ),
  unutilLossCFNorm: field("Unutilised losses carried forward", ""),
  unutilDonationCFNorm: field("Unutilised donations carried forward", ""),
  totalRevenue: field("Total Revenue", ""),
  grossPL: field("Gross Profit / (Loss)", ""),
  directorFee: field("Director fees & remuneration", ""),
  totRemuneration: field("Total remuneration (exclude director fees)", ""),
  medicalExp: field("Medical expenses", ""),
  c1_TransportExp: field("Transport / travelling expenses", ""),
  c1_EntertainExp: field("Entertainment expenses", ""),
  inventories: field("Inventories", ""),
  tradeReceivables: field("Trade receivables", ""),
  sholderChange: field(
    "Substantial change in shareholders",
    "Is there a substantial change in the company's ultimate shareholders and their shareholdings as at the relevant dates?"
  ),
  uCALDChangePrinAct: field(
    "Change in principal activities",
    "Is there a change in the principal activities of the company during the basis period?"
  ),
  unutilCALDClaimS23S37: field(
    "Unutilised capital allowances/losses/donations (CA/LD) claim under Section 23/Section 37",
    "Unutilised Capital Allowances / Losses / Donations claimed where waiver of the shareholding test under Section 23 / Section 37 has been / will be granted by IRAS"
  ),
  fullTxX: field(
    "Qualifies for start-up tax exemption",
    "Has the company satisfied all conditions to qualify for the Tax Exemption Scheme for New Start-Up Companies?"
  ),
  expRD: field(
    "Research and development (R&D) deduction (Section 14C)",
    "Deduction for Expenditure Incurred on Research and Development (R&D) undertaken in Singapore and Overseas - Total Deduction under Section 14C"
  ),
  expRDSG: field(
    "Research and development (R&D) in Singapore (Section 14C)",
    "Section 14C Deduction for Expenditure Incurred on Research and Development (R&D) Activities undertaken in Singapore"
  ),
  enhanceDeductRD: field(
    "Enhanced deduction (Section 14D(1))",
    "Staff Costs and Consumables for Research and Development (R&D) activities undertaken in Singapore Qualifying for the Additional 150% Tax Deduction under Section 14D(1) in excess of the $400,000 cap under the Enterprise Innovation Scheme"
  ),
  appStockConvAsset: field(
    "Stock / capital asset conversion",
    "Has the company appropriated any trading stock for non-trade or capital purposes under Section 10J and/or converted any non-trade or capital asset to trading stock under Section 32A?"
  ),
  c1_EnhancedEISDed: field(
    "Total Enterprise Innovation Scheme (EIS) enhanced deduction",
    "Enhanced Deductions under Enterprise Innovation Scheme (EIS) for Training; Innovation Projects carried out with Partner Institutions; Licensing of Intellectual Property Rights; Registration of Intellectual Property; Qualifying Research and Development (R&D) undertaken in Singapore"
  ),
  eis_ClaimCashPayout: field(
    "Claim Enterprise Innovation Scheme (EIS) cash payout",
    "Is the company claiming cash payout under the Enterprise Innovation Scheme (EIS) in this current Year of Assessment (YA)?"
  ),
  eis_ClaimDedAll: field(
    "Claim Enterprise Innovation Scheme (EIS) enhanced deduction",
    "Is the company claiming enhanced deductions / allowances under the Enterprise Innovation Scheme (EIS) in this current Year of Assessment (YA)?"
  ),
  eis_TrainTotCost: field(
    "Training - total cost",
    "Training Total Qualifying Cost Incurred"
  ),
  eis_TrainDedAll: field(
    "Training - Enhanced Deductions / Allowances Claimed / To Be Claimed",
    ""
  ),
  eis_InnoProjTotCost: field(
    "Innovation project - total cost",
    "Innovation Projects Carried Out with Partner Institutions\n\nTotal Qualifying Cost Incurred (capped at $50,000)"
  ),
  eis_InnoProjDedAll: field(
    "Innovation project - Enhanced Deductions / Allowances Claimed / To Be Claimed",
    "Innovation Projects Carried Out with Partner Institutions Enhanced Deductions / Allowances Claimed / To Be Claimed"
  ),
  eis_AcqIPRTotCost: field(
    "Acquisition of intellectual property rights (IPR) - total cost",
    "Acquisition of Intellectual Property Rights (IPRs)\nTotal Qualifying Cost Incurred"
  ),
  eis_AcqIPRDedAll: field(
    "Acquisition of intellectual property rights (IPR) - Enhanced Deductions / Allowances Claimed / To Be Claimed",
    "Acquisition of Intellectual Property Rights (IPRs) Enhanced Deductions / Allowances Claimed / To Be Claimed"
  ),
  eis_LicensIPRTotCost: field(
    "Licensing of intellectual property rights (IPR) - total cost",
    "Licensing of Intellectual Property Rights (IPRs)\nTotal Qualifying Cost Incurred"
  ),
  eis_LicensIPRDedAll: field(
    "Licensing of intellectual property rights (IPR) - Enhanced Deductions / Allowances Claimed / To Be Claimed",
    ""
  ),
  eis_RegIPTotCost: field(
    "Intellectual property (IP) registration - total cost",
    "Registration of Intellectual Property (IPs)\nTotal Qualifying Cost Incurred"
  ),
  eis_RegIPDedAll: field(
    "Intellectual property (IP) registration - Enhanced Deductions / Allowances Claimed / To Be Claimed",
    "Registration of Intellectual Property (IPs) Enhanced Deductions / Allowances Claimed / To Be Claimed"
  ),
  eis_RDSgTotCost: field(
    "Research and development (R&D) in Singapore - total cost",
    "Qualifying Research and Development (R&D) Undertaken in Singapore\n\nTotal Qualifying Cost Incurred"
  ),
  eis_RDSgDedAll: field(
    "Research and development (R&D) in Singapore - Enhanced Deductions / Allowances Claimed / To Be Claimed",
    "Qualifying Research and Development (R&D) Undertaken in Singapore\nEnhanced Deductions / Allowances Claimed / To Be Claimed"
  ),
  ptisDonInd: field(
    "Philanthropy Tax Incentive Scheme for Family Offices (PTIS) qualifying overseas donor",
    "Is the company an approved qualifying donor making qualifying overseas donations under the Philanthropy Tax Incentive Scheme for Family Offices (PTIS)?"
  ),
  foreignAssetsSaleGainLoss: field(
    "Foreign asset disposal gain/loss",
    "Amount of gains / losses from the sale or disposal of foreign assets during the basis period for the current Year of Assessment (YA)"
  ),
  foreignSourceSaleGainsRemit: field(
    "Foreign source gains remitted to Singapore",
    "Amount of the foreign-sourced sale or disposal gains remitted to Singapore during the basis period for the current Year of Assessment (YA)"
  ),
  foreignSourceSaleNotTax: field(
    "Section 10L(8) not taxable",
    "Do the foreign-sourced sale or disposal gains / losses fall under any of the scenarios where the sale or disposal of foreign assets (excluding foreign intellectual property rights (IPRs)) is not subject to tax under Section 10L(8) of the Income Tax Act (ITA)?"
  ),
};

export const DATA_FORM_CS_SECTION_META = {
  basisPeriod: section(
    "Basis period & financial statements",
    "Accounting period, financial statement preparation, and Singapore Chartered Tax Professionals (SCTP) review details."
  ),
  taxAdjustments: section(
    "Tax adjustments",
    "Main tax computation adjustments."
  ),
  bfDonations: section("Brought forward & donations"),
  plSupplement: section(
    "Profit/loss & balance sheet supplement",
    "Profit and loss overview, operating expenses, then balance sheet items."
  ),
  qualificationChanges: section("Qualification & changes"),
  rd: section(
    "Research & development (R&D)",
    "Section 14C / 14D - enter all three amounts in Singapore dollars (SGD)."
  ),
  stockAppropriation: section(
    "Appropriation of Trading Stock or Conversion of Non-Trade/ Capital Asset",
    "Declare whether trading stock or non-trade/capital assets were appropriated or converted."
  ),
  section10L: section(
    "Gain/Losses from the Sale or Disposal of Foreign Assets - Section 10L",
    "Complete the Section 10L declaration and related foreign asset amounts."
  ),
  eis: section(
    "Enterprise Innovation Scheme (EIS)",
    "Confirm eligibility, declare claims, then complete the expense breakdown when required."
  ),
  ptis: section(
    "Philanthropy Tax Incentive Scheme for Family Offices (PTIS) declaration",
    "Confirm whether the company is a qualifying overseas donor.",
    "PTIS is the Philanthropy Tax Incentive Scheme for Family Offices."
  ),
  sctpReviewer: section(
    "Singapore Chartered Tax Professionals (SCTP) reviewer details"
  ),
  taxBaseProfit: section(
    "Base profit",
    "Starting figures before tax adjustments."
  ),
  taxRegularAdjustments: section(
    "Regular adjustments",
    "Non-taxable receipts and non-deductible expenses."
  ),
  taxFinalResult: section(
    "Deductions & final result",
    "Further deductions through to balancing charge."
  ),
  bfCurrentIncome: section(
    "Brought forward & current income",
    "Opening balances, current-year income components, and total before donations."
  ),
  bfDonationIncome: section(
    "Donations & chargeable income",
    "Donation brought forward, current donations, and chargeable income."
  ),
  bfClosing: section(
    "Carried forward to next period",
    "Closing balances carried forward (paired with opening brought forward)."
  ),
  profitOverview: section(
    "Profit overview",
    "Key P&L headline figures for the period."
  ),
  operatingExpenses: section(
    "Operating expenses",
    "People-related and day-to-day operating costs."
  ),
  balanceSheetItems: section(
    "Balance sheet items",
    "Assets and inventory (not P&L expense lines)."
  ),
  companyChanges: section(
    "Company changes",
    "Shareholding and principal activity declarations."
  ),
  taxExemptions: section(
    "Tax exemptions",
    "Start-up tax exemption eligibility."
  ),
  amountDeclaration: section(
    "Amount declaration",
    "Enter the Unutilised Capital Allowances / Losses / Donations claimed where waiver of the shareholding test under Section 23 / Section 37 has been / will be granted by IRAS."
  ),
  researchDevelopment: section(
    "Research & development",
    "Base Section 14C deductions and Section 14D(1) enhanced amount."
  ),
  eisOverview: section(
    "Enhanced deduction",
    "Enter the total enhanced deduction claimed under the Enterprise Innovation Scheme (EIS)."
  ),
  eisClaimOptions: section(
    "Claim options",
    "Select whether to claim cash payout and/or enhanced deduction."
  ),
  eisExpenses: section(
    "Breakdown of Enterprise Innovation Scheme (EIS) expenses",
    "Cost and enhanced deduction for each qualifying activity."
  ),
  overseasDonations: section(
    "Overseas donations",
    "Philanthropy Tax Incentive Scheme for Family Offices (PTIS) qualifying overseas donor (when current-year donations apply)."
  ),
  foreignAssetDisposal: section(
    "Section 10L details",
    "Tax treatment, gains/losses, and remittance to Singapore."
  ),
};

export const getDataFormCSFieldMeta = (key) => ({
  key,
  label: DATA_FORM_CS_FIELD_META[key]?.label ?? key,
  description: DATA_FORM_CS_FIELD_META[key]?.description ?? "",
});

export const getDataFormCSSectionMeta = (key) => ({
  key,
  title: DATA_FORM_CS_SECTION_META[key]?.title ?? key,
  description: DATA_FORM_CS_SECTION_META[key]?.description ?? "",
  info: DATA_FORM_CS_SECTION_META[key]?.info ?? "",
});

export const SCTP_IND_OPTIONS = [
  { value: "0", label: "Select an option" },
  { value: "1", label: "Yes" },
  { value: "2", label: "No" },
];

export const FS_PREP_OPTIONS = [
  { value: "0", label: "Select an option" },
  { value: "1", label: "1 set of accounts" },
  { value: "2", label: "2 sets of accounts" },
];

export const YES_NO_NUMBER_OPTIONS = [
  { value: "0", label: "Select an option" },
  { value: "1", label: "Yes" },
  { value: "2", label: "No" },
];

export const YES_NO_BLANK_OPTIONS = [
  // { value: "N.A.", label: "Not Applicable" },
  { value: "1", label: "Yes" },
  { value: "2", label: "No" },
];

export const YES_NO_YN_OPTIONS = [
  { value: "Y", label: "Yes" },
  { value: "N", label: "No" },
  { value: "NA", label: "Not Applicable" },
];

export const TAX_ADJUSTMENT_FIELDS = [
  "profitLossBeforeTaxation",
  "sepSrcIncome",
  "receiptNotTxAmt",
  "c1_NTDeductibleExp",
  "adjPLBefDed",
  "renoWorksExpS14Q",
  "c1_FurtherDed",
  "sgAdjPLAft",
  "c1_BC",
];

export const TAX_ADJUSTMENT_GROUPS = [
  {
    sectionKey: "taxBaseProfit",
    column: "left",
    keys: ["profitLossBeforeTaxation", "sepSrcIncome"],
  },
  {
    sectionKey: "taxRegularAdjustments",
    column: "left",
    keys: ["receiptNotTxAmt", "c1_NTDeductibleExp", "adjPLBefDed"],
  },
  {
    sectionKey: "taxFinalResult",
    column: "right",
    keys: [
      "renoWorksExpS14Q",
      "c1_EnhancedEISDed",
      "c1_FurtherDed",
      "sgAdjPLAft",
      "c1_BC",
    ],
  },
].map((group) => ({
  ...getDataFormCSSectionMeta(group.sectionKey),
  ...group,
}));

export const BF_DONATION_FIELDS = [
  "unutilCABFNorm",
  "cyCANorm",
  "unutilLossBFNorm",
  "c1_GrossRent",
  "c1_DedExp",
  "sgRent",
  "sgIntDisc",
  "sgOtherI",
  "totSgFI",
  "unutilDonationBFNorm",
  "cyDonation",
  "cyOverseasDonation",
  "ci",
  "unutilCACFNorm",
  "unutilLossCFNorm",
  "unutilDonationCFNorm",
];

export const BF_DONATION_BF_KEYS = ["unutilCABFNorm", "unutilLossBFNorm"];

export const BF_DONATION_CF_KEYS = [
  "unutilCACFNorm",
  "unutilLossCFNorm",
  "unutilDonationCFNorm",
];

export const BF_DONATION_GROUPS = [
  {
    sectionKey: "bfCurrentIncome",
    layout: "income",
    keys: [
      "unutilCABFNorm",
      "cyCANorm",
      "unutilLossBFNorm",
      "c1_GrossRent",
      "c1_DedExp",
      "sgRent",
      "sgIntDisc",
      "sgOtherI",
      "totSgFI",
    ],
  },
  {
    sectionKey: "bfDonationIncome",
    layout: "donation",
    keys: ["unutilDonationBFNorm", "cyDonation", "cyOverseasDonation", "ci"],
  },
  {
    sectionKey: "bfClosing",
    keys: ["unutilCACFNorm", "unutilLossCFNorm", "unutilDonationCFNorm"],
    variant: "closing",
  },
].map((group) => ({
  ...getDataFormCSSectionMeta(group.sectionKey),
  ...group,
}));

export const PL_SUPPLEMENT_FIELDS = [
  "totalRevenue",
  "grossPL",
  "directorFee",
  "totRemuneration",
  "medicalExp",
  "c1_TransportExp",
  "c1_EntertainExp",
  "inventories",
  "tradeReceivables",
];

export const PL_SUPPLEMENT_PEOPLE_EXPENSE_KEYS = [
  "directorFee",
  "totRemuneration",
];

export const PL_SUPPLEMENT_OPERATING_EXPENSE_KEYS = [
  "medicalExp",
  "c1_TransportExp",
  "c1_EntertainExp",
];

export const PL_SUPPLEMENT_BALANCE_SHEET_KEYS = [
  "inventories",
  "tradeReceivables",
];

/** Amount fields that may be negative (losses / chargeable losses). */
export const SIGNED_AMOUNT_FIELDS = new Set([
  "profitLossBeforeTaxation",
  "adjPLBefDed",
  "sgAdjPLAft",
  "foreignAssetsSaleGainLoss",
  "grossPL",
  "totSgFI",
  "ci",
]);

export const EIS_EXPENSE_GROUPS = [
  {
    title: "Training",
    totalCostKey: "eis_TrainTotCost",
    deductionKey: "eis_TrainDedAll",
  },
  {
    title: "Innovation projects with partner institutions",
    totalCostKey: "eis_InnoProjTotCost",
    deductionKey: "eis_InnoProjDedAll",
  },
  {
    title: "Acquisition of intellectual property rights (IPR)",
    totalCostKey: "eis_AcqIPRTotCost",
    deductionKey: "eis_AcqIPRDedAll",
  },
  {
    title: "Licensing of intellectual property rights (IPR)",
    totalCostKey: "eis_LicensIPRTotCost",
    deductionKey: "eis_LicensIPRDedAll",
  },
  {
    title: "Registration of intellectual property (IP)",
    totalCostKey: "eis_RegIPTotCost",
    deductionKey: "eis_RegIPDedAll",
  },
  {
    title: "Research and development (R&D) undertaken in Singapore",
    totalCostKey: "eis_RDSgTotCost",
    deductionKey: "eis_RDSgDedAll",
  },
];

export const EIS_AMOUNT_FIELDS = EIS_EXPENSE_GROUPS.flatMap(
  ({ totalCostKey, deductionKey }) => [totalCostKey, deductionKey]
);
